import React, { useState, useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import MantenimientosTable from './shared/MantenimientosTable';
import MantenimientoSlideOver from './MantenimientoSlideOver';
import { categorizar } from './shared/useFlota';

export default function ProximosPage() {
  const { mantenimientos, isLoading, refetch } = useOutletContext();
  const [detalleId, setDetalleId] = useState(null);

  const rows = useMemo(() => {
    const c = categorizar(mantenimientos);
    return [...c.vencidos, ...c.proximos].sort(
      (a, b) => (a.fecha_programada || '').localeCompare(b.fecha_programada || '')
    );
  }, [mantenimientos]);

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Typography sx={{ fontSize: 22, fontWeight: 800, color: '#0f172a' }}>Próximos mantenimientos</Typography>
        <Typography sx={{ fontSize: 12, color: '#64748b' }}>
          {rows.length} tarea(s) pendientes. Los vencidos aparecen primero.
        </Typography>
      </Box>

      <MantenimientosTable rows={rows} loading={isLoading}
        onRowClick={r => setDetalleId(r.id)}
        emptyTitle="Sin mantenimientos pendientes"
        emptyMessage="Cuando programes un mantenimiento, aparecerá aquí." />

      {detalleId && (
        <MantenimientoSlideOver mantenimientoId={detalleId}
          onClose={() => setDetalleId(null)} onUpdated={refetch} />
      )}
    </Box>
  );
}
